// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"393d1af3","167":"b5e0f4bf","226":"537472d2","449":"f0678d26"}[chunkId] + ".chunk.css";
};